import languages from './languages';
import type { Lucid } from '../../types/types';
import { isLanguageCode, isLanguageShortCode, isLanguageURLPrefix } from '../guards';
import getLanguageData from './getLanguageData';

/** @returns `english` as the default language */
const defaultLanguage = () => languages.filter(language => language.short_code === 'en')[0];

/**
 * @param languageKey
 * @returns `I18n.DirectusLanguage` `@default EN`
 */
const getLanguage = (languageKey: string): Lucid.I18n.Languages => {
  if (isLanguageCode(languageKey)) {
    const currentLanguage = getLanguageData(languageKey, 'code');

    if (currentLanguage) return currentLanguage;
  }

  if (isLanguageShortCode(languageKey)) {
    const currentLanguage = getLanguageData(languageKey, 'short_code');

    if (currentLanguage) return currentLanguage;
  }

  if (isLanguageURLPrefix(languageKey)) {
    const currentLanguage = getLanguageData(languageKey, 'url_lang_prefix');

    if (currentLanguage) return currentLanguage;
  }

  return defaultLanguage();
};

export default getLanguage;
